<template>
  <!-- @click.self="closeDialog" -->
  <div class="pop-dialog-conver">
    <div
      class="pop-dialog-container"
      :class="boxMaxWidth ? 'boxMaxWidth' : ''"
      :style="{ 'max-width': maxWidth, transform: `translate(${x}px, ${y}px)` }"
    >
      <div
        class="pop-dialog-header"
        :draggable="drag"
        @dragstart="mousedown($event)"
        @dragend="mouseup($event)"
      >
        <span>{{ title }}</span>
        <div
          class="dialog-close"
          v-if="showCloseButton"
          @click="closeDialog"
        ></div>
      </div>
      <div class="pop-dialog-body">
        <slot :data="popDataObj">
          <span v-if="detailShowType == 'message'">{{ message }}</span>
          <!-- 查看到这边 -->
          <el-form
            v-if="detailShowType == 'data'"
            class="pop-dialog-body-data"
            :model="formData"
            label-width="auto"
            label-position="top"
            :rules="rules"
            ref="editForm"
            :inline-message="true"
            :status-icon="true"
          >
            <el-form-item
              v-for="(item, index) in dataMeta"
              :key="`pop-dialog-body-data${index}`"
              class="pop-dialog-body-data-item"
              :label="item.label"
              :prop="item.dataIndex"
            >
              <field
                :type="item.type"
                v-model:value="formData[item.dataIndex]"
                :fieldData="item.fieldData"
                :showLabel="false"
                :selectRemoteSearchData="item.selectRemoteSearchData"
                :showSelectPagenation="item.showSelectPagenation"
                :rangeSeparator="item.rangeSeparator"
                :selectValueFn="item.selectValueFn"
                :tabelRow="tabelRow"
                :readOnly="isReadOnly(item.readOnly)"
                :formData="formData"
                :clearable="item.clearable"
                :refKey="item.refKey"
                :rows="item.rows"
              >
              </field>
            </el-form-item>
            <el-form-item label="" v-if="userPassword">
              <el-button
                :type="type"
                style="margin-top: 86%"
                @click="resetClick"
                >重置密码</el-button
              >
            </el-form-item>
          </el-form>
          <!-- ToExamine -->
          <p v-if="approve" style="color: red">审批信息</p>
          <div v-if="approve" class="toExamine">
            <div class="inputBox">
              <div class="label">用户名</div>
              <el-input
                :type="text"
                class="input-container-input"
                v-model="popRowTemplate.ToNewUserName"
                size="small"
                :disabled="true"
              />
            </div>

            <div class="inputBox">
              <div class="label">Email</div>
              <el-input
                :type="text"
                class="input-container-input"
                v-model="popRowTemplate.ToNewEmail"
                size="small"
                :disabled="true"
              />
            </div>

            <div class="inputBox">
              <div class="label">电话</div>
              <el-input
                :type="text"
                class="input-container-input"
                v-model="popRowTemplate.ToNewPhone"
                size="small"
                :disabled="true"
              />
            </div>

            <div class="inputBox">
              <div class="label">公司</div>
              <el-input
                :type="text"
                class="input-container-input"
                v-model="popRowTemplate.ToNewCompanyName"
                size="small"
                :disabled="true"
              />
            </div>
          </div>
        </slot>
      </div>
      <div class="pop-dialog-footer" v-if="showButtons">
        <slot name="popFooter">
          <confirm-button
            v-if="approve"
            class="pop-dialog-footer-button"
            @buttonClick="btnApproveClick"
            >审批</confirm-button
          >
          <cancel-button
            class="pop-dialog-footer-button"
            v-if="approve"
            @buttonClick="closeApproveDialog"
            >拒绝
          </cancel-button>

          <confirm-button
            v-if="showConfirm"
            class="pop-dialog-footer-button"
            @buttonClick="btnConfirmClick"
            >{{ textButtons }}</confirm-button
          >
          <confirm-button
            v-if="textFinish"
            class="pop-dialog-footer-button"
            @buttonClick="btnFinishClick"
            >{{ textFinish }}</confirm-button
          >
          <cancel-button
            class="pop-dialog-footer-button"
            v-if="showCancelButton"
            @buttonClick="closeDialog"
            >取消
          </cancel-button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import cancelButton from "@/components/cancelButton.vue";
import confirmButton from "@/components/comfirmButton.vue";
import field from "@/components/textField.vue";
import { defineComponent, reactive, toRefs, watch, ref, computed } from "vue";

export default defineComponent({
  name: "popDialog",
  components: {
    cancelButton,
    confirmButton,
    field,
  },
  props: {
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    meta: {
      type: Array,
      default: null,
    },
    message: {
      type: String,
      default: "测试",
    },
    showButtons: {
      type: Boolean,
      default: true,
    },
    textButtons: {
      type: String,
      default: "确定",
    },
    showCancelButton: {
      type: Boolean,
      default: true,
    },
    detailShowType: {
      type: String,
      default: "message", //message data
    },
    formDataWatch: {
      type: Object,
      default: null,
    },
    userPassword: {
      type: String,
      default: null,
    },
    boxMaxWidth: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: String,
      default: "80%",
    },
    textFinish: {
      type: String,
      default: "",
    },
    showConfirm: {
      type: Boolean,
      default: true,
    },
    popRowTemplate: {
      type: Object,
      default: null,
    },
    approve: {
      type: Boolean,
      default: false,
    },
    drag: {
      type: Boolean,
      default: true,
    },
  },
  emits: [
    "dialogClose",
    "confirmClick",
    "update:formDataWatch",
    "FinishClick",
    "btnApproveClick",
    "closeApproveDialog",
  ],
  setup(props, { emit }) {
    let data = reactive({
      showDialog: false,
      dataMeta: [],
      id: "",
      title: "新增",
      popDataObj: {},
      formData: {},
      rules: {},
      isAdd: true,
      tabelRow: {},
      editForm: null,
      x: 0,
      y: 0,
      clientX: 0,
      clientY: 0,
    });
    let resetPassword = ref(0);
    let type = ref("info");
    let methods = {
      mousedown(e) {
        console.log("按下-", e);
        data.clientX = e.clientX;
        data.clientY = e.clientY;
      },

      mouseup(e) {
        let dataX = e.clientX - data.clientX;
        let dataY = e.clientY - data.clientY;
        data.x += dataX;
        data.y += dataY;

        console.log("x-x", data.x);
        console.log("x-y", data.y);
        // data.x = e.clientX
        // data.y = e.clientY

        // data.$emit('drag', dx, dy)
      },
      resetClick() {
        if (resetPassword.value) {
          resetPassword.value = 0;
          type.value = "info";
        } else {
          type.value = "success";
          resetPassword.value = 1;
        }
      },
      closeDialog() {
        emit("dialogClose");
      },
      btnConfirmClick() {
        console.log("保存");
        let form = data.editForm;
        if (form) {
          form.validate((success) => {
            if (success) {
              let id = data.id;

              let reset = resetPassword.value;
              let dt = {
                id,
                ...data.formData,
                reset,
              };
              // debugger
              let slotData = dt;
              let title = dt.title;

              let formPostData = new FormData();

              // let keys = Object.keys(dt);
              // console.log(dt,'查看一下')
              // keys.forEach((f) => {
              //   //  debugger
              //   if (f == "IsDefault") {
              //     console.log(typeof f, 78978888);
              //     // IsDefault
              //     if (typeof dt[f] == "undefined") {
              //       dt[f] = false;
              //     } else if (dt[f] == true) {
              //       dt[f] = true;
              //     } else {
              //       dt[f] = false;
              //     }
              //   }
              // if (f == "IsDefault") {
              //   console.log(typeof f, 78978888);
              //   if (typeof dt[f] == "undefined") {
              //     dt[f] = false;
              //   } else if (dt[f][0] == true) {
              //     dt[f] = true;
              //   } else if (dt[f].length == 0) {
              //     dt[f] = false;
              //   }
              // }
              // if(f=='IsDefault'&&dt[f][0]==true){
              //   // console.log(dt[f],'dtaaa',typeof(dt[f]))
              //   dt[f]=true
              // }
              //  console.log(f,'typeof',dt[f])
              //  return
              //   formPostData.append(f, dt[f]);
              // });

              emit("confirmClick", {
                id,
                title,
                formPostData,
                slotData,
              });
            }
          });
        } else {
          let id = data.id;

          if (!data.popDataObj) {
            emit("confirmClick");
            return;
          }
          let slotData = data.popDataObj;
          let title = data.title;

          let formPostData = new FormData();

          let keys = Object.keys(data.popDataObj);
          keys.forEach((f) => {
            formPostData.append(f, slotData[f]);
          });
          emit("confirmClick", {
            id,
            title,
            formPostData,
            slotData,
          });
        }
      },
      btnApproveClick() {
        console.log("审批");
        let slotData = props.popRowTemplate;
        emit("confirmClick", {
          title: "审批",
          slotData,
        });
      },
      closeApproveDialog() {
        console.log("拒绝");
        let slotData = props.popRowTemplate;
        emit("confirmClick", {
          title: "拒绝",
          slotData,
        });
      },
      btnFinishClick() {
        console.log("完成");
        let slotData = data.popDataObj;
        let id = data.id;
        emit("FinishClick", {
          id,
          slotData,
        });
      },
      showPopDialog(parms, title, slotName, isAdd) {
        data.tabelRow = parms;

        data.isAdd = isAdd == null ? true : isAdd;
        data.title = title;

        data.dataMeta = [];
        methods.convertMeta(props.meta);
        data.formData = {};
        methods.createFormData(props.meta);

        if (!slotName) {
          if (data.dataMeta) {
            if (parms) {
              data.dataMeta.forEach((f) => {
                f.value = parms[f.dataIndex];
              });

              let keys = Object.keys(parms);
              // 将所有的data中的formData的value属性设置为，每一行的对应的dataIndex，
              // 将row中的所有的属性给到formdata
              keys.forEach((k) => {
                data.formData[k] = parms[k];
              });
            } else {
              data.dataMeta.forEach((f) => {
                f.value = null;
              });

              data.id = null;
            }
          }
        } else {
          data.popDataObj = parms;
        }

        let form = data.editForm;

        if (form) {
          form.clearValidate();
        }
        // debugger
      },
      convertMeta(meta) {
        //   将tabel里面所有的rowcolumn作为字段推到里面
        if (meta) {
          meta.forEach((f) => {
            if (!f.groups || f.groups.length == 0) {
              if (f.editable === true) {
                data.dataMeta.push({
                  type: f.editType, //类型
                  label: f.headerLabel, //名称
                  dataIndex: f.dataIndex, //字段名
                  value: null, //值
                  requird: f.requird, //是否必须
                  fieldData: f.fieldData,
                  selectRemoteSearchData: f.selectRemoteSearchData,
                  showSelectPagenation: f.showSelectPagenation,
                  rangeSeparator: f.rangeSeparator,
                  selectValueFn: f.selectValueFn,
                  readOnly: f.readOnly,
                  refKey: f.refKey,
                  clearable: f.clearable,
                  rows: f.rows,
                });

                data.rules[f.dataIndex] = f.rules;
              }
            } else {
              methods.convertMeta(f.groups);
            }
          });
        }
      },
      createFormData(meta) {
        if (meta) {
          meta.forEach((f) => {
            if (!f.groups || f.groups.length == 0) {
              if (f.editable === true) {
                data.formData[f.dataIndex] = f.value;
              }
            } else {
              methods.createFormData(f.groups);
            }
          });
        }
      },
      isReadOnly(value) {
        if (data.isAdd) {
          return false;
        } else {
          return value;
        }
      },
    };
    let computeds = {
      tableColumns: computed(() => {
        return props.rowTemplate.filter((f) => f.showInList !== false);
      }),
      detailItems: computed(() => {
        const res = props.rowTemplate.filter((f) => {
          return (
            f.showInDetail !== false &&
            f.columnType != "index" &&
            f.columnType != "check"
          );
        });

        return res;
      }),
      // { "label": "用户名", "dataIndex": "UserName", "value": "何继龙" }
      popRowEdit: computed(() => {
        return Array.from(Object.values(props.popRowTemplate));
      }),
    };

    watch(
      () => {
        return data.formData;
      },
      (newValue) => {
        emit("update:formDataWatch", newValue);
      }
    );

    return {
      ...toRefs(data),
      ...methods,
      ...computeds,
      resetPassword,
      type,
    };
  },
});
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

.pop-dialog-conver {
  @include background_color("pop-dialog-conver-bg-color");
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  overflow: hidden;
  position: absolute;
  box-sizing: border-box;
  z-index: 10;
  top: 0;
  left: 0;

  &.pop-dialog-close {
    opacity: 0;
    transform: scale(0);
    transition: all 0.3s;
    z-index: -1000;
  }

  .pop-dialog-container {
    height: auto;
    width: fit-content;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    @include font_family("font_family");
    @include background_color("pop-dialog-bg-color");
    @include border_all("pop-dialog-border");
    border-radius: 10px;
    overflow: hidden;
    max-width: 1200px;
    min-width: 480px;
    max-height: 800px;
    padding-bottom: 20px;

    .pop-dialog-header {
      display: flex;
      @include background_color("pop-dialog-header-bg-color");
      font-size: 20px;
      @include font_color("pop-dialog-header-font-color");
      justify-content: space-between;
      align-items: center;
      align-content: center;
      box-sizing: border-box;
      padding-left: 20px;
      padding-right: 20px;
      width: 100%;
      height: 48px;
      box-sizing: border-box;

      .dialog-close {
        height: 20px;
        width: 20px;
        @include background_image("pop-dialog-header-close");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        box-sizing: border-box;

        &:hover {
          opacity: 0.6;
        }
      }
    }

    .pop-dialog-body {
      box-sizing: border-box;
      padding-top: 20px;
      width: 100%;
      height: auto;
      padding-left: 40px;
      padding-right: 40px;
      font-size: 18px;
      @include font-color("pop-dialog-content-font-color");
      word-wrap: break-word;
      overflow: auto;

      .pop-dialog-body-data {
        display: flex;
        flex-wrap: wrap;
        height: auto;
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
        box-sizing: border-box;

        .pop-dialog-body-data-item {
          width: 280px;
          height: fit-content;
          margin-left: 50px;
          box-sizing: border-box;
        }
      }
    }

    .pop-dialog-footer {
      margin-top: 72px;
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
      box-sizing: border-box;

      .pop-dialog-footer-button {
        height: 100%;
        margin-left: 20px;
        width: 80px;
        height: 40px;

        &:first-child {
          margin-left: 0px;
        }
      }
    }
  }
  .boxMaxWidth {
    // width:100%;
    max-width: 80%;
  }
  .toExamine {
    display: flex;
    justify-content: space-around;
    .inputBox {
      display: flex;
      width: 260px;
      div.label {
        width: 80px;
      }
    }
  }
}
</style>
